import { render, staticRenderFns } from "./CierreGuiaAprobar.vue?vue&type=template&id=60d36d8e"
import script from "./CierreGuiaAprobar.vue?vue&type=script&lang=js"
export * from "./CierreGuiaAprobar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports